import {getCorrectBooleanValue} from "@/utils/helpers"
import entity from "../../advertisingBanner/mixins/entity";

export default {
	data() {
		return {
			dateFields: ['assignable_to'],
			entityName: 'service',
			moduleName: 'services',
			detailPageRouteName: 'serviceDetail',
			entity: {
				'id_operator': '0',
				'id_business_model': '0',
				'id_weight_category': '0',
				'timeshift': null,
				'pvr': null,
				'pvr_free_minutes': null,
				'pvr_lifetime_in_days': null,
				'catchup': null,
				'catchup_hours': null,
				'device_count': null,
				'device_addon': null,
                'subscriber_profile_count': null,
                'subscriber_profile_addon': null,
				'valid_from': null,
				'valid_to': null,
				'assignable_to': null,
				'time_with_no_advertisement_after_start_seconds': null,
				'time_with_no_advertisement_after_start_seconds_nonlinear': null,
				'skip_after_seconds': null,
				'skip_after_seconds_nonlinear': null,
				'skippable': null,
				'skippable_nonlinear': null,
				'autoskip': false,
				'allow_skip_multiple_advertisement_blocks': false,
				'allow_skip_multiple_advertisement_blocks_nonlinear': false,
				'periodic_pvr': null,
				'periodic_pvr_count': null,
				'periodic_pvr_days_back': null,
				'periodic_pvr_addon': null,
				'id_vod_package': null,
				'vod': null,
			},
			updateFields: [
				'name',
				'note',
				'id_operator',
				'id_business_model',
				'id_weight_category',
				'timeshift',
				'pvr',
				'pvr_free_minutes',
				'pvr_lifetime_in_days',
				'catchup',
				'catchup_hours',
				'valid_from',
				'valid_to',
				'assignable_to',
				'id_channels',
				'id_channel_packages',
				'non_linear_content_settings',
				'device_count',
				'device_addon',
                'subscriber_profile_count',
                'subscriber_profile_addon',
				'skip_after_seconds',
				'skip_after_seconds_nonlinear',
				'skippable',
				'skippable_nonlinear',
				'autoskip',
				'time_with_no_advertisement_after_start_seconds',
				'time_with_no_advertisement_after_start_seconds_nonlinear',
				'allow_skip_multiple_advertisement_blocks',
				'allow_skip_multiple_advertisement_blocks_nonlinear',
				'periodic_pvr',
				'periodic_pvr_count',
				'periodic_pvr_days_back',
				'periodic_pvr_addon',
				'id_vod_package',
				'vod',
			],
			serviceWeightCategories: [],
			nonLinearContentSettings: [],
			initialNonLinearContentSettingsCount: 0,
		}
	},
	computed: {
		nonLinearOptions() {
			return [
				{id: null, text: this.$gettext('Neurčeno')},
				{id: true, text: this.$gettext('Ano')},
				{id: false, text: this.$gettext('Ne')},
			]
		},
		weightCategoriesOptions() {
			let options = []
			this._.forEach(this.serviceWeightCategories, function (weightCategory) {
				options.push({
					id: weightCategory['id'],
					text: weightCategory['name'] + ' (' + weightCategory['value'] + ')'
				})
			})
			return options
		},
		catchupHours: {
			get() {
				return this.entity.catchup_hours
			},
			set(newValue) {
				if (newValue === '') {
					this.entity.catchup_hours = null
				} else {
					this.entity.catchup_hours = Number(newValue)
				}
			}
		},
		catchup: {
			get() {
				return this.entity.catchup
			},
			set(newValue) {
				this.entity.catchup = getCorrectBooleanValue(newValue)
			}
		},
		timeshift: {
			get() {
				return this.entity.timeshift
			},
			set(newValue) {
				this.entity.timeshift = getCorrectBooleanValue(newValue)
			}
		},
		pvr: {
			get() {
				return this.entity.pvr
			},
			set(newValue) {
				this.entity.pvr = getCorrectBooleanValue(newValue)
			}
		},
		periodic_pvr: {
			get() {
				return this.entity.periodic_pvr
			},
			set(newValue) {
				this.entity.periodic_pvr = getCorrectBooleanValue(newValue)
			}
		},
		vod: {
			get() {
				return this.entity.vod
			},
			set(newValue) {
				this.entity.vod = getCorrectBooleanValue(newValue)
			}
		},
		skippable: {
			get() {
				return this.entity.skippable
			},
			set(newValue) {
				this.entity.skippable = getCorrectBooleanValue(newValue)
			}
		},
		skippableNonlinear: {
			get() {
				return this.entity.skippable_nonlinear
			},
			set(newValue) {
				this.entity.skippable_nonlinear = getCorrectBooleanValue(newValue)
			}
		},
		skipAfterSeconds: {
			get() {
				return this.entity.skip_after_seconds
			},
			set(newValue) {
				if (newValue === '') {
					this.entity.skip_after_seconds = null
				} else {
					this.entity.skip_after_seconds = Number(newValue)
				}
			}
		},
		skipAfterSecondsNonlinear: {
			get() {
				return this.entity.skip_after_seconds_nonlinear
			},
			set(newValue) {
				if (newValue === '') {
					this.entity.skip_after_seconds_nonlinear = null
				} else {
					this.entity.skip_after_seconds_nonlinear = Number(newValue)
				}
			}
		},
		timeWithNoAdvertisementAfterStartSeconds: {
			get() {
				return this.entity.time_with_no_advertisement_after_start_seconds
			},
			set(newValue) {
				if (newValue === '') {
					this.entity.time_with_no_advertisement_after_start_seconds = null
				} else {
					this.entity.time_with_no_advertisement_after_start_seconds = Number(newValue)
				}
			}
		},
		timeWithNoAdvertisementAfterStartSecondsNonlinear: {
			get() {
				return this.entity.time_with_no_advertisement_after_start_seconds_nonlinear
			},
			set(newValue) {
				if (newValue === '') {
					this.entity.time_with_no_advertisement_after_start_seconds_nonlinear = null
				} else {
					this.entity.time_with_no_advertisement_after_start_seconds_nonlinear = Number(newValue)
				}
			}
		},
		allowSkipMultipleAdvertisementBlocks: {
			get() {
				return this.entity.allow_skip_multiple_advertisement_blocks
			},
			set(newValue) {
				this.entity.allow_skip_multiple_advertisement_blocks = getCorrectBooleanValue(newValue)
			}
		},
		allowSkipMultipleAdvertisementBlocksNonlinear: {
			get() {
				return this.entity.allow_skip_multiple_advertisement_blocks_nonlinear
			},
			set(newValue) {
				this.entity.allow_skip_multiple_advertisement_blocks_nonlinear = getCorrectBooleanValue(newValue)
			}
		},
		autoskip: {
			get() {
				return this.entity.autoskip
			},
			set(newValue) {
				this.entity.autoskip = getCorrectBooleanValue(newValue)
			}
		},
		canEditBusinessModel() {
			return Boolean(Number(this.entity.id_operator) === 0)
		},
		operatorIdComputed: {
			get() {
				if (this.entity.id_operator === null) {
					return '0'
				} else {
					return this.entity.id_operator
				}
			},
			set(newValue) {
				this.setBusinessModelByOperatorId(newValue)
				this.entity.id_operator = newValue
				let value = this.operatorIdComputed;
			},
		},
		businessModelIdComputed: {
			get() {
				if (this.entity.id_business_model === null) {
					return '0'
				} else {
					return this.entity.id_business_model
				}
			},
			set(newValue) {
				this.entity.id_business_model = newValue
			}
		},
		allowSkipAfter() {
			return !this.entity.autoskip && this.entity.skippable;
		},
		allowSkipAfterNonlinear() {
			return !this.entity.autoskip && this.entity.skippable_nonlinear;
		},
	},
	methods: {
		processParamsBeforeCreateAndUpdate(params, update = false) {
			if (this._.trim(params['id_operator']) === '' || this._.trim(params['id_operator']) === '0') {
				params['id_operator'] = null
			}
			if (this._.trim(params['id_business_model']) === '' || this._.trim(params['id_business_model']) === '0') {
				params['id_business_model'] = null
			}
			if (this._.has(params, 'catchup_hours') && this._.trim(params['catchup_hours']) === '') {
				params['catchup_hours'] = null
			}
			if (this._.has(params, 'pvr_lifetime_in_days') && this._.trim(params['pvr_lifetime_in_days']) === '') {
				params['pvr_lifetime_in_days'] = null
			}
			if (this._.has(params, 'pvr_free_minutes') && this._.trim(params['pvr_free_minutes']) === '') {
				params['pvr_free_minutes'] = null
			}
			if (this._.has(params, 'periodic_pvr_count') && this._.trim(params['periodic_pvr_count']) === '') {
				params['periodic_pvr_count'] = null
			}
			if (this._.has(params, 'periodic_pvr_days_back') && this._.trim(params['periodic_pvr_days_back']) === '') {
				params['periodic_pvr_days_back'] = null
			}

			this.processBooleanParams(params)

			if (this.nonLinearContentSettings) {
				if (this.nonLinearContentSettings.length > 0) {
					params['non_linear_content_settings'] = [...this.nonLinearContentSettings]
				} else {
					if (this.initialNonLinearContentSettingsCount > 0) {
						params['non_linear_content_settings'] = null
					} else {
						this._.unset(params, 'non_linear_content_settings')
					}
				}
			}
			return params
		},
		processBooleanParams(params) {
			this._.forEach(['pvr', 'catchup', 'timeshift'], (key) => {
				params[key] = getCorrectBooleanValue(params[key])
			})

			return params
		},
		updateEntityDate(dateInfo) {
			this.entity[dateInfo.attrKey] = dateInfo.date
		},
		_processDetailErrorMessage(error) {
			let nameError = null
			let pvrDaysError = null
			let pvrFreeMinutesError = null
			let catchupError = null
			let deviceError = null;
			let advertisementError = null;
			let advertisementNonlinerError = null;
			let periodicPvrCountError = null;
			let periodicPvrDaysBackError = null;

			this._.forEach(error['validation_errors'], function (errorMessage) {
				if (this._.includes(errorMessage, 'Service with given name') &&
					this._.includes(errorMessage, 'already exists')) {
					nameError = this.$gettext('Název musí být unikátní')
				}
				if (this._.includes(errorMessage, 'are not allowed to be combined with other packages of certain types')) {
					error['error_message'] = this.$gettext('Vybrané balíčky se nemůžou kombinovat.')
				}
				if (this._.includes(errorMessage, 'which is allowed to be combined with thematic package(s) before you add thematic package(s)')) {
					error['error_message'] = this.$gettext('Nelze přidat tematický balíček, když služba neobsahuje základní balíček s možností kombinace s tematickými.')
				}
				if (this._.includes(errorMessage, 'Unable to delete service') &&
					this._.includes(errorMessage, 'subscribers with given service')) {
					error['error_message'] = this.$gettext('Službu není možné smazat - je přiřazená odběratelům.')
				}
				if (errorMessage === 'PVR lifetime in days must be at least 1.') {
					pvrDaysError = this.$gettext('Hodnota musí být větší než 0')
				}
				if (errorMessage === 'Service\'s pvr lifetime in days must be number.') {
					pvrDaysError = this.$gettext('Zadejte číslo')
				}
				if (errorMessage === 'PVR free minutes and PVR lifetime in days must be set when pvr is allowed.') {
					pvrDaysError = this.$gettext('Zadejte číslo')
					pvrFreeMinutesError = this.$gettext('Zadejte číslo')
				}
				if (errorMessage === 'PVR free minutes must be at least 1.') {
					pvrFreeMinutesError = this.$gettext('Hodnota musí být větší než 0')
				}
				if (errorMessage === 'Service\'s pvr free minutes must be number.') {
					pvrFreeMinutesError = this.$gettext('Zadejte číslo')
				}
				if (errorMessage === 'Catchup hours must be number.'
					|| errorMessage === 'Catchup hours must be set when catchup is allowed.'
				) {
					catchupError = this.$gettext('Zadejte číslo')
				}
				if (errorMessage === 'Catchup hours must be at least 1.') {
					catchupError = this.$gettext('Hodnota musí být větší než 0')
				}
				if(errorMessage === 'Service\'s device count must be number.'){
					deviceError = this.$gettext("Zadejte číslo")
				}
				if(errorMessage === 'Device count must be at least 1.'){
					deviceError = this.$gettext("Hodnota musí být větší než 0")
				}
				if(errorMessage === 'Skip after seconds must be set when skippable is allowed.'){
					advertisementError = this.$gettext("Povinné, pokud je povoleno přeskakování reklam v živém vysílání.")
				}
				if(errorMessage === 'Skip after seconds nonlinear must be set when skippable nonlinear is allowed.'){
					advertisementNonlinerError = this.$gettext("Povinné pokud je povoleno přeskakování reklam v nelineárním vysílání.")
				}
				if(errorMessage === "Service's periodic pvr count must be number."){
					periodicPvrCountError = this.$gettext('Počet periodických nahrávek musí být číslo');
				}
				if(errorMessage === "Service's periodic pvr days back must be number."){
					periodicPvrDaysBackError = this.$gettext('Počet dní za catchup u periodických nahrávek musí být číslo');
				}
				if(errorMessage === "Parameter periodic_pvr_days_back cannot be without parameter periodic_pvr_count filled."){
					periodicPvrDaysBackError = this.$gettext('Musí být vyplněn i minimální počet nahrávek.');
				}
			}.bind(this))

			if (!this.entity.name) {
				nameError = this.$gettext('Zadejte název')
			} else if (this.entity.name.length < 3) {
				nameError = this.$gettext('Název musí obsahovat min. 3 znaky')
			}

			if (nameError !== null) {
				this.setFieldInvalid('servicenameref', true, nameError)
			} else {
				this.setFieldInvalid('servicenameref')
			}

			if (!this.entity.id_weight_category) {
				this.setFieldInvalid('serviceweightref', true, this.$gettext('Zadejte váhu'))
			} else {
				this.setFieldInvalid('serviceweightref')
			}

			if (pvrDaysError !== null) {
				this.setFieldInvalid('pvrlifetimeref', true, pvrDaysError)
			} else {
				this.setFieldInvalid('pvrlifetimeref')
			}

			if (pvrFreeMinutesError !== null) {
				this.setFieldInvalid('pvrfreeminutesref', true, pvrFreeMinutesError)
			} else {
				this.setFieldInvalid('pvrfreeminutesref')
			}

			if (catchupError !== null) {
				this.setFieldInvalid('catchuphoursref', true, catchupError)
			} else if (this.entity.catchup_hours !== null && isNaN(this.entity.catchup_hours)) {
				this.setFieldInvalid('catchuphoursref', true, this.$gettext('Zadejte číslo'))
			} else {
				this.setFieldInvalid('catchuphoursref')
			}

			if(deviceError !== null){
				this.setFieldInvalid('devicecountsref', true, deviceError)
			} else {
				this.setFieldInvalid('devicecountsref')
			}

			if(advertisementError !== null){
				this.setFieldInvalid('skipaftersecondsref', true, advertisementError)
			}else{
				this.setFieldInvalid('skipaftersecondsref')
			}

			if(advertisementNonlinerError !== null){
				this.setFieldInvalid('skipaftersecondsnonlinearref', true, advertisementNonlinerError)
			}else{
				this.setFieldInvalid('skipaftersecondsnonlinearref')
			}

			if(periodicPvrCountError !== null){
				this.setFieldInvalid('periodicpvrcountref', true, periodicPvrCountError)
			} else {
				this.setFieldInvalid('periodicpvrcountref')
			}

			if(periodicPvrDaysBackError !== null){
				this.setFieldInvalid('periodicpvrdaysbackref', true, periodicPvrDaysBackError)
			} else {
				this.setFieldInvalid('periodicpvrdaysbackref')
			}

			return error['error_message']
		},
		resetFields() {
			this.setFieldInvalid('servicenameref')
			this.setFieldInvalid('serviceweightref')
			this.setFieldInvalid('pvrlifetimeref')
			this.setFieldInvalid('pvrfreeminutesref')
			this.setFieldInvalid('catchuphoursref')
			this.setFieldInvalid('skipaftersecondsref')
			this.setFieldInvalid('skipaftersecondsnonlinearref')
			this.setFieldInvalid('periodicpvrcountref')
			this.setFieldInvalid('periodicpvrdaysbackref')
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/services/mixins/services.js